import { NextUIProvider } from "@nextui-org/system";

import { AppRoutes } from "./routes";

import { HighlightProvider } from "@/client_app/context/HighlightContext";
import { AppProvider } from "@/client_app/providers/app";

interface AppProps {
  backendContext: unknown;
}

export const App = ({ backendContext }: AppProps): JSX.Element => {
  return (
    <NextUIProvider>
      <HighlightProvider>
        <AppProvider backendContext={backendContext}>
          <AppRoutes />
        </AppProvider>
      </HighlightProvider>
    </NextUIProvider>
  );
};
